import { Box, styled } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { navBarChromeSurfaceStyles } from '../NavBarChrome';

export const StyledStickyContainer = styled(Box)<{ backgroundColor: string; isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  ${({ backgroundColor }) => navBarChromeSurfaceStyles(backgroundColor)}
  transition: ${animationTransition('transform')};
  display: flex;
  justify-content: center;
  transform: translate3d(0, ${props => (props.isVisible ? '0' : '-100%')}, 0);
  will-change: transform;
  backface-visibility: hidden;
`;
